import { cn } from '@/lib/utils';

export interface FilterTab {
  label: string;
  value: string;
  icon?: React.ReactNode;
  count?: number;
}

interface FilterTabsProps {
  tabs: FilterTab[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export function FilterTabs({ tabs, value, onChange, className }: FilterTabsProps) {
  return (
    <div className={cn('flex items-center gap-1 bg-slate-100 rounded-lg p-1', className)}>
      {tabs.map((tab) => (
        <button
          key={tab.value}
          type="button"
          className={cn(
            'px-3 py-1.5 text-sm font-medium rounded-md transition-colors',
            value === tab.value
              ? 'bg-white text-slate-900 shadow-sm'
              : 'text-slate-600 hover:text-slate-900',
          )}
          onClick={() => onChange(tab.value)}
        >
          {tab.icon && <span className="inline-flex mr-1 -mt-0.5">{tab.icon}</span>}
          {tab.count != null && tab.count > 0 && (
            <span className={cn(
              'font-semibold mr-1',
              value === tab.value ? 'text-blue-600' : 'text-blue-400',
            )}>
              {tab.count.toLocaleString()}
            </span>
          )}
          {tab.label}
        </button>
      ))}
    </div>
  );
}
